import './App.css';
import { mount } from 'svelte';
import App from './App.svelte';
import { setupI18n } from './lib/i18n';

console.log('🌟 main.ts executed - page is loading/reloading');

// Initialize internationalization
setupI18n();

const app = mount(App, {
  target: document.getElementById('app')!,
});

console.log('✅ App mounted');

export default app;
